<template>
    <div id="joinIB">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <div class="card shadow-sm text-center">
                        <div class="card-body p-5">
                            <div class="icon-wrapper mb-4">
                                <i class="fa fa-lock icon-large"></i>
                            </div>
                            <h1 class="txt-title mb-3">Partnership Access Required</h1>
                            <p class="lead text-muted mb-4">
                                Sorry, you need to become an Introducing Broker (IB) first to access the Partnership
                                features.
                            </p>
                            <div class="divider my-4"></div>
                            <div class="cta-buttons">
                                <a href="/dashboard" class="btn btn-outline-secondary px-4 py-2">
                                    <i class="fa fa-arrow-left mr-2"></i>
                                    Back to Dashboard
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "JoinIB",
};
</script>

<style scoped>
#joinIB {
    padding-bottom: 3rem;
    margin-top: 100px;
    display: flex;
    align-items: center;
}

.card {
    border: none;
    border-radius: 12px;
    background-color: #fafafa;
    border: 2px solid #e0e0e0;
}

.text-yellow {
    color: #c09a07;
}

.txt-title {
    font-size: 2.25rem;
    font-weight: 700;
    color: #333;
}

.lead {
    font-size: 1.15rem;
    line-height: 1.6;
    color: #666;
}

/* Icon */
.icon-wrapper {
    width: 100px;
    height: 100px;
    background: linear-gradient(135deg, #c09a07 0%, #a88506 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    box-shadow: 0 4px 20px rgba(192, 154, 7, 0.3);
}

.icon-large {
    font-size: 3rem;
    color: white;
}

/* Divider */
.divider {
    height: 1px;
    background: linear-gradient(to right, transparent, #d3d3d3, transparent);
}

/* Buttons */
.btn-outline-secondary {
    border: 2px solid #6c757d;
    color: #6c757d;
    border-radius: 8px;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.btn-outline-secondary:hover {
    background-color: #6c757d;
    color: white;
    transform: translateY(-2px);
    text-decoration: none;
}

.cta-buttons {
    margin-top: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
    #joinIB {
        margin-top: 80px;
    }

    .txt-title {
        font-size: 1.75rem;
    }

    .lead {
        font-size: 1rem;
    }

    .icon-wrapper {
        width: 80px;
        height: 80px;
    }

    .icon-large {
        font-size: 2.5rem;
    }

    .card-body {
        padding: 2rem !important;
    }

    .btn-outline-secondary {
        width: 100%;
        margin-bottom: 0.5rem;
    }
}
</style>
